import React, { useEffect, useRef, useState } from 'react';
import { createStyledButton, useParticleBackground, injectButtonStyles, bingoLogo,
  BINGO_URL_HOST, BINGO_URL_PLAYER } from '@buzztime-bingo/utils';
import './App.css';
import ButtonClickSound from './assets/sounds/old-radio-button-click.mp3';

// Import the sound file directly
const playButtonSound = () => {
  console.log('Attempting to play sound...');
  const audio = new Audio(ButtonClickSound);
  
  // Add event listeners for debugging
  audio.addEventListener('canplaythrough', () => console.log('Sound loaded successfully'));
  audio.addEventListener('playing', () => console.log('Sound is playing'));
  audio.addEventListener('error', (e) => console.error('Sound error:', e));
  
  // Play the sound
  audio.play()
    .then(() => console.log('Sound played successfully'))
    .catch(err => console.error('Sound play error:', err));
};

function App() {
  const containerRef = useRef(null);
  const tokenHandledRef = useRef(false);

  injectButtonStyles();

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Rubik+Mono+One&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    if (!tokenHandledRef.current) {
      tokenHandledRef.current = true;
    }
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  // Use the existing particle background component
  useParticleBackground({
    id: "particles",
    leftColor: "#00FFFF",  // Cyan
    rightColor: "#de3e8eff"  // Pink
  });

  // Add global CSS styles for buttons using the utility function
  useEffect(() => {
    // Using the createStyledButton utility for consistent button styling
    const { cleanup } = createStyledButton({
      id: "landing-buttons"
    });

    return cleanup;
  }, []);

  return (
    <div className="app-container" ref={containerRef}>
      <div className="logo-container">
      <img src={bingoLogo} alt="Buzztime Bingo Logo" className="logo" />
      </div>
      <div className="button-container">
        <a href={`${BINGO_URL_HOST}/`} className="btn btn-primaryCyan" onClick={(e) => {
          e.preventDefault();
          playButtonSound();
          setTimeout(() => window.location.href = `${BINGO_URL_HOST}/`, 450);
        }}>
          <span className="shadow"></span>
          <span className="front">Host</span>
        </a>
        <a href={`${BINGO_URL_PLAYER}/`} className="btn btn-primaryPink" onClick={(e) => {
          e.preventDefault();
          playButtonSound();
          setTimeout(() => window.location.href = `${BINGO_URL_PLAYER}/`, 450);
        }}>
          <span className="shadow"></span>
          <span className="front">Join</span>
        </a>
      </div>
    </div>
  );
}

export default App;